module.exports = __webpack_public_path__ + "static/media/equipe-tindog.88973da5.png";